module.exports = __webpack_public_path__ + "static/media/key_green.1804f2b1.svg";